module.exports = __webpack_public_path__ + "img/no-sensor-marker.a519697c.svg";